import React from 'react';
import styled from "styled-components";
import {PRIMARY_COLOR} from "../constants/colors";

const Container = styled.button`
  padding: .5rem .7rem;
  border: none;
  border-radius: 8px;
  min-width: 150px;
  transition: .3s;
  ${props => {
    switch (props.varient) {
      case 'primary':
        return `
            background-color: ${PRIMARY_COLOR};
            color: #FFF;
             &:hover {
                background-color: #1970e1;
            }
          `;

      default:
        return `
            background-color: ${PRIMARY_COLOR},
            color: #FFF,
             &:hover {
                background-color: #1970e1;
            }
          `;
    }
  }};
`

const Button = ({...otherProps}) => {
    return (
        <Container {...otherProps}/>
    );
};

export default Button;
